// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__8VprD","errorLogs":"EditorFooter_errorLogs__1wz3c"};